module.exports = __webpack_public_path__ + "media/step_5_ru.9ec21c50.mp3";